import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import SelectDropdown from "../../components-react/SelectDropdown";
import CloseSubmitBtn from "../../common-components/custom-comps/CloseSubmitBtn";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import {
  fetchBroadcastVariablesData,
  fetchBroadcastWPTemplatesData,
} from "../../../redux/ad-blog-reducers/blogSlice";
import ReactQuillTextEditor from "../../components-react/inputs/ReactQuillTextEditor";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import VariableForm from "../variables/VariableForm";
import { validateBCASchedulerForm } from "../Validations";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import {
  bca_scheduler_condition,
  scheduler_types,
  wati_accounts,
} from "../../common-data/DropdowData";

const BCASchedulerForm = ({
  isEdit,
  rowData,
  closeModal,
  userInfoData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const {
    broadcastWPTemplates,
    broadcastWPTemplatesLoading,
    broadcastWPTemplatesError,

    broadcastVariables,
    broadcastVariablesLoading,
    broadcastVariablesError,
  } = useSelector((state) => state.blog);

  const [wpTemplates, setWpTemplates] = useState([]);
  const [variables, setVariables] = useState([]);

  const iniwaTemplates = [
    {
      selectedWPTemplate: null,
      variables: {},
      expanded: true,
    },
  ];
  const [waTemplates, setWATemplates] = useState(iniwaTemplates);
  const [waContainerExpanded, setWAContainerExpanded] = useState(true);
  const forminitials = {
    schedulerName: "",
    selectedScheduleType: "",
    selectedCondition: "",
    beforeDays: "",
    afterDays: "",
    description: "",
    templates: [],
    isActive: false,
    selectedWhatsappAccount: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const getWPTemplates = (filters) => {
    dispatch(
      fetchBroadcastWPTemplatesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  const getVariables = (filters) => {
    dispatch(
      fetchBroadcastVariablesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  const extractVariableKeys = (body) => {
    if (!body) return [];
    const regex = /{{(\d+)}}/g;
    let match;
    const keys = [];
    while ((match = regex.exec(body))) {
      keys.push(match[1]);
    }
    return keys;
  };

  const handleTemplateChange = (value, idx) => {
    const keys = extractVariableKeys(value?.info?.body);
    setWATemplates((prev) =>
      prev.map((item, i) =>
        i === idx
          ? {
              ...item,
              selectedWPTemplate: value,
              variables: keys.reduce((acc, key) => {
                acc[key] = "";
                return acc;
              }, {}),
            }
          : item
      )
    );
  };

  const handleVariableChange = (idx, key, selectedValue) => {
    setWATemplates((prev) =>
      prev.map((item, i) =>
        i === idx
          ? {
              ...item,
              variables: {
                ...item.variables,
                [key]: selectedValue?.value,
              },
            }
          : item
      )
    );
  };

  const handleAddTemplate = () => {
    setWATemplates((prev) => [
      ...prev,
      { selectedWPTemplate: null, variables: {}, expanded: true },
    ]);
  };

  const handleRemoveTemplate = (idx) => {
    setWATemplates((prev) => prev.filter((_, i) => i !== idx));
  };

  const getVariableKeys = (item) => {
    return extractVariableKeys(item.selectedWPTemplate?.info?.body);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);

    if (name === "selectedCondition") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        beforeDays: value?.value === "upcoming" ? "" : "0",
        afterDays: value?.value === "upcoming" ? "0" : "",
      }));
      return;
    } else if (name === "selectedWhatsappAccount") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        selectedWPTemplate: "",
        selectedWPTemplateVariables: {},
      }));
      setWATemplates(iniwaTemplates);
      setVariables([]);
      return;
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const onChangeInput = (e) => {
    setIsSubmit(false);

    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmitForm = async (payload) => {
    try {
      const method = isEdit ? "PUT" : "POST";
      const endpoint = "/wati/schedule_broadcast";
      const token = userInfoData?.token || "";

      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);

        closeModal();
        callFunction?.();
        toast.success(result?.payload?.message || "Successfully scheduled!");
      } else {
        const errorMessage =
          result?.payload?.data ||
          result?.payload?.message ||
          result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error processing template:", error);
      toast.error("Failed to process template");
    }
  };

  const onSumitForm = (e) => {
    e.preventDefault();
    setFormErrors(validateBCASchedulerForm({ ...formValues, waTemplates }));
    setIsSubmit(true);
  };

  useEffect(() => {
    if (formValues.selectedWhatsappAccount?.value) {
      const sendableWPTemplateFilters = {
        page: 1,
        limit: 3000,
        status: "APPROVED",
        whatsapp_account: formValues.selectedWhatsappAccount.value,
      };

      getWPTemplates(sendableWPTemplateFilters);
    }
  }, [formValues.selectedWhatsappAccount]);

  useEffect(() => {
    const sendableFilters = {
      page: 1,
      limit: 3000,
      status: "active",
    };

    getVariables(sendableFilters);
  }, []);

  useEffect(() => {
    if (
      !broadcastVariablesLoading &&
      !broadcastVariablesError &&
      broadcastVariables?.status &&
      broadcastVariables?.data?.length > 0
    ) {
      const dropdownOptions = broadcastVariables.data.map((item) => ({
        label: item.value?.replace(/_/g, " "),
        value: item.uid,
        info: item,
      }));

      setVariables(dropdownOptions);
    } else {
      setVariables([]);
    }
  }, [broadcastVariables, broadcastVariablesLoading, broadcastVariablesError]);

  useEffect(() => {
    if (
      !broadcastWPTemplatesLoading &&
      !broadcastWPTemplatesError &&
      broadcastWPTemplates?.status &&
      broadcastWPTemplates?.data?.length > 0
    ) {
      const dropdownOptions = broadcastWPTemplates.data.map((item) => ({
        label: item.elementName?.replace(/_/g, " "),
        value: item.elementName,
        info: item,
      }));

      setWpTemplates(dropdownOptions);
    } else {
      setWpTemplates([]);
    }
  }, [
    broadcastWPTemplates,
    broadcastWPTemplatesLoading,
    broadcastWPTemplatesError,
  ]);

  useEffect(() => {
    if (rowData && wpTemplates.length > 0 && variables.length > 0) {
      setFormValues({
        schedulerName: rowData.name || "",
        selectedCondition:
          bca_scheduler_condition.find(
            (opt) => opt.value === rowData.condition
          ) || "",
        beforeDays: rowData.before_day ?? 0,
        afterDays: rowData.after_day ?? 0,
        description: rowData.description || "",
        isActive: rowData.status === "active" ? true : false,
        selectedWhatsappAccount:
          wati_accounts.find((opt) => opt.value === rowData.whatsapp_account) ||
          "",
      });

      setWATemplates(
        (rowData.templates || []).map((tpl) => {
          const selectedWPTemplate =
            wpTemplates.find(
              (opt) => opt.value === tpl.whatsapp_template_name
            ) || null;
          const variablesObj = {};
          (tpl.whatsapp_variable_json || []).forEach((v) => {
            variablesObj[v.key] = v.variableId;
          });
          return {
            selectedWPTemplate,
            variables: variablesObj,
            expanded: true,
          };
        })
      );
    }
  }, [rowData, wpTemplates, variables]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        name: formValues.schedulerName || "",
        description: formValues.description || "",
        condition: formValues.selectedCondition?.value || "",
        before_day: Number(formValues.beforeDays) || 0,
        after_day: Number(formValues.afterDays) || 0,
        templates: waTemplates.map((item) => ({
          whatsapp_template_name: item.selectedWPTemplate?.value || "",
          whatsapp_template_body: item.selectedWPTemplate?.info?.body || "",
          whatsapp_variable_json: getVariableKeys(item).map((key) => ({
            key,
            variableId: item.variables[key] || "",
          })),
        })),
        status: formValues.isActive ? "active" : "inactive",
        user_type: "member",
        condition_type: formValues.selectedScheduleType?.value || "",
        channel: "whatsapp",
        whatsapp_account: formValues.selectedWhatsappAccount?.value || "",
      };

      if (isEdit) {
        userData.uid = rowData.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure you want to schedule this broadcast?`,
        "No, Cancel",
        "Yes, Submit"
      );
    }
  }, [isSubmit, formErrors]);

  console.log("formErrors=> ", formErrors);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer mod-width-50p">
          {modValues.modName !== "add-variable" && (
            <ModalHeadAndClose
              title={"Template Details"}
              onClose={onCloseModal}
            />
          )}

          {modValues.modName === "add-variable" ? (
            <VariableForm
              closeModal={onCloseModal}
              userInfoData={userInfoData}
              callFunction={() => {
                const sendableFilters = {
                  page: 1,
                  limit: 3000,
                  status: "active",
                };
                getVariables(sendableFilters);
              }}
            />
          ) : null}
        </div>
      </Modal>

      <div className="form-container mt15">
        <form className="formContainer">
          <div className="formInputsGrid threeGridSystem">
            <div className="formInputBox">
              <label htmlFor="schedulerName" className={`formInputLabel`}>
                Scheduler Name <span className="required">*</span>
              </label>

              <input
                type="text"
                placeholder="Enter scheduler name"
                className={`formInput ${
                  formErrors?.schedulerName ? "formError" : ""
                }`}
                name="schedulerName"
                value={formValues.schedulerName}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label
                htmlFor="selectedScheduleType"
                className={`formInputLabel`}
              >
                Schedule Type <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedScheduleType ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={scheduler_types}
                  selectedOption={formValues.selectedScheduleType}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedScheduleType")
                  }
                  name="Schedule Type"
                />
              </div>
            </div>

            <div className="formInputBox">
              <label htmlFor="selectedCondition" className={`formInputLabel`}>
                Condition <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedCondition ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={bca_scheduler_condition}
                  selectedOption={formValues.selectedCondition}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedCondition")
                  }
                  name="Condition"
                />
              </div>
            </div>

            {formValues.selectedCondition?.value === "upcoming" ? (
              <div className="formInputBox">
                <label htmlFor="beforeDays" className={`formInputLabel`}>
                  Before Days <span className="required">*</span>
                </label>

                <input
                  type="number"
                  placeholder="Enter before days"
                  className={`formInput ${
                    formErrors?.beforeDays ? "formError" : ""
                  }`}
                  name="beforeDays"
                  value={formValues.beforeDays}
                  onChange={onChangeInput}
                  min={0}
                />

                <span className="tiny-info-label">
                  ⓘ in case os same day broadcast, enter 0
                </span>
              </div>
            ) : (
              <div className="formInputBox">
                <label htmlFor="afterDays" className={`formInputLabel`}>
                  After Days <span className="required">*</span>
                </label>

                <input
                  type="number"
                  placeholder="Enter after days"
                  className={`formInput ${
                    formErrors?.afterDays ? "formError" : ""
                  }`}
                  name="afterDays"
                  value={formValues.afterDays}
                  onChange={onChangeInput}
                  min={0}
                />

                <span className="tiny-info-label">
                  ⓘ in case os same day broadcast, enter 0
                </span>
              </div>
            )}

            <div className="formInputBox">
              <label
                htmlFor="selectedWhatsappAccount"
                className={`formInputLabel`}
              >
                wati Account <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedWhatsappAccount ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={wati_accounts}
                  selectedOption={formValues.selectedWhatsappAccount}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedWhatsappAccount")
                  }
                  name="wati account"
                />
              </div>
            </div>
          </div>

          <div className="formInputsGrid twoGridSystem">
            <div className="formInputBox">
              <label htmlFor="description" className={`formInputLabel`}>
                brief about the broadcast <span className="required">*</span>
              </label>

              <textarea
                placeholder="Enter description"
                className={`formInput ${
                  formErrors.description ? "formError" : ""
                }`}
                name="description"
                value={formValues.description}
                onChange={onChangeInput}
              />
            </div>
          </div>

          {formValues.selectedWhatsappAccount && (
            <div
              className="bca_schduler-wa-templates-outer"
              style={{ width: "100%" }}
            >
              <div
                className="bca_schduler-wa-templates-header"
                onClick={() => setWAContainerExpanded((prev) => !prev)}
                style={{ cursor: "pointer" }}
              >
                <span className="bca_schduler-wa-templates-label">
                  WhatsApp Templates
                </span>

                <span className="bca_schduler-wa-templates-header-right">
                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={() =>
                      window.open(
                        "https://live-18717.wati.io/18717/messageTemplate",
                        "_blank"
                      )
                    }
                  >
                    Create New Template
                  </button>

                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={(e) => {
                      e.stopPropagation();
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "add-variable",
                      }));
                    }}
                  >
                    Create New Variable
                  </button>

                  <span className="bca_schduler-wa-templates-count">
                    {waTemplates.length}
                  </span>

                  <span className="bca_schduler-wa-templates-toggle">
                    {waContainerExpanded ? "▲" : "▼"}
                  </span>
                </span>
              </div>

              {waContainerExpanded && (
                <>
                  {waTemplates.map((item, idx) => (
                    <div
                      className="bca_schduler-wa-template-accordion expanded"
                      key={idx}
                    >
                      <div className="bca_schduler-wa-template-header">
                        <span className="bca_schduler-wa-template-index">
                          Template {idx + 1}
                        </span>
                        {waTemplates.length > 1 && (
                          <button
                            type="button"
                            className="bca_schduler-remove-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveTemplate(idx);
                            }}
                            title="Remove"
                          >
                            X
                          </button>
                        )}
                      </div>

                      <div className="bca_schduler-wa-template-body formInputsGrid twoGridSystem">
                        <div className="formInputBox span2">
                          <label className="formInputLabel">
                            Template{" "}
                            <b
                              style={{ cursor: "pointer", fontSize: "30px" }}
                              onClick={() => {
                                if (formValues.selectedWhatsappAccount?.value) {
                                  const sendableEmailTemplateFilters = {
                                    page: 1,
                                    limit: 3000,
                                    status: "active",
                                    whatsapp_account:
                                      formValues.selectedWhatsappAccount.value,
                                  };

                                  getWPTemplates(sendableEmailTemplateFilters);
                                }
                              }}
                            >
                              ⥁
                            </b>{" "}
                            <span className="required">*</span>
                          </label>

                          <div
                            className={`commonWrapper ${
                              formErrors?.waTemplates?.[idx]?.selectedWPTemplate
                                ? "formError"
                                : ""
                            }`}
                          >
                            <SelectDropdown
                              options={wpTemplates}
                              selectedOption={item.selectedWPTemplate}
                              setSelectedOption={(value) =>
                                handleTemplateChange(value, idx)
                              }
                              name={`template`}
                            />
                          </div>
                        </div>

                        {item.selectedWPTemplate && (
                          <div className="formInputBox span2">
                            <label htmlFor="body" className="formInputLabel">
                              template body
                            </label>

                            <div className="commonWrapper textAreaCommonWrapper with-auto-height no-border disabled">
                              <ReactQuillTextEditor
                                value={
                                  item.selectedWPTemplate?.info?.body || ""
                                }
                                isError={formErrors?.body}
                                loading={true}
                              />
                            </div>

                            <span className="tiny-info-label">
                              ⓘ Replace the variables with your values!
                            </span>
                          </div>
                        )}

                        {item.selectedWPTemplate && (
                          <div className="formInputBox span2">
                            <label className="formInputLabel">
                              Template Variables{" "}
                              <b
                                style={{ cursor: "pointer", fontSize: "30px" }}
                                onClick={() => {
                                  const sendableVariableFilters = {
                                    page: 1,
                                    limit: 3000,
                                    status: "active",
                                  };

                                  getVariables(sendableVariableFilters);
                                }}
                              >
                                ⥁
                              </b>{" "}
                              <span className="required">*</span>
                            </label>

                            {getVariableKeys(item).length === 0 && (
                              <div className="bca_schduler-no-vars">
                                No variables found.
                              </div>
                            )}

                            <div className="bca_schduler-variable-list mt10">
                              {getVariableKeys(item).map((key) => (
                                <div
                                  className="bca_schduler-variable-row"
                                  key={key}
                                >
                                  <span className="bca_schduler-variable-label">
                                    Key: {key}
                                  </span>
                                  <div
                                    className={`commonWrapper ${
                                      formErrors?.waTemplates?.[idx]
                                        ?.variables?.[key]
                                        ? "formError"
                                        : ""
                                    }`}
                                  >
                                    <SelectDropdown
                                      options={variables}
                                      selectedOption={variables.find(
                                        (v) => v.value === item.variables[key]
                                      )}
                                      setSelectedOption={(selectedValue) =>
                                        handleVariableChange(
                                          idx,
                                          key,
                                          selectedValue
                                        )
                                      }
                                      name={`variable`}
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}

                  <div style={{ textAlign: "right", marginTop: "1rem" }}>
                    <button
                      type="button"
                      className="bca_schduler-add-btn"
                      onClick={handleAddTemplate}
                    >
                      + Add More
                    </button>
                  </div>
                </>
              )}
            </div>
          )}

          <div className="formInputBox checkbox-wrapper">
            <div className="flex-box">
              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formValues.isActive}
                  onChange={onChangeInput}
                />
                {formValues.isActive ? "Active" : "Inactive"}
              </label>
            </div>
          </div>

          <CloseSubmitBtn
            closeLabel="Cancel"
            submitLabel={"Submit"}
            onClose={closeModal}
            onSubmit={onSumitForm}
            isLoading={postPutLoading}
          />
        </form>
      </div>
    </>
  );
};

export default BCASchedulerForm;
